import ManufacturerLoginTemp from "../../templates/ManufacturerTemp/manufacurerLogin";

const ManufacturerLogin = () => <ManufacturerLoginTemp />;

export default ManufacturerLogin;